import React from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  HStack,
  Badge,
  Divider,
  Icon,
} from '@chakra-ui/react';
import { FiAlertCircle, FiInfo, FiFileText, FiShield } from 'react-icons/fi';
import { Link } from 'react-router-dom';

function Disclaimer() {
  return (
    <Box bg="#F8FAFC" minH="100vh" py={{ base: 8, md: 12 }}>
      {/* Header Banner */}
      <Box
        bg="linear-gradient(135deg, #0B132B 0%, #162237 60%, #1E293B 100%)"
        color="white"
        py={{ base: 12, md: 16 }}
        mb={{ base: 8, md: 12 }}
      >
        <Container maxW="5xl" px={{ base: 4, md: 8 }} textAlign="center">
          <Badge
            bg="rgba(234, 179, 8, 0.15)"
            color="#FACC15"
            border="1px solid"
            borderColor="rgba(234, 179, 8, 0.3)"
            px={3.5}
            py={1}
            borderRadius="full"
            fontSize="xs"
            fontWeight="semibold"
            letterSpacing="wider"
            textTransform="uppercase"
            mb={3}
          >
            Legal Notice & Terms
          </Badge>
          <Heading as="h1" size={{ base: 'xl', md: '2xl' }} fontWeight="extrabold">
            Website & Publication Disclaimer
          </Heading>
          <Text fontSize="sm" color="gray.300" mt={2}>
            Notice regarding legal citations, judicial software databases, and retail literature
          </Text>
        </Container>
      </Box>

      {/* Main Document Content */}
      <Container maxW="5xl" px={{ base: 4, md: 8 }}>
        <Box
          bg="white"
          p={{ base: 6, md: 12 }}
          borderRadius="2xl"
          border="1px solid"
          borderColor="gray.100"
          boxShadow="sm"
        >
          {/* Important Callout */}
          <Box p={5} bg="amber.50" borderRadius="xl" border="1px solid" borderColor="#FDE68A" mb={8}>
            <HStack align="flex-start" spacing={3}>
              <Icon as={FiAlertCircle} boxSize={5} color="#B45309" mt={0.5} />
              <Box>
                <Text fontWeight="bold" fontSize="sm" color="#92400E">
                  Notice to Advocates & Researchers
                </Text>
                <Text fontSize="xs" color="#78350F" mt={1} lineHeight="tall">
                  The contents published on this site, catalog descriptions, and legal research software modules are intended for informational, pedagogical, and judicial reference purposes only. They do not constitute formal legal counsel or advocate-client representation.
                </Text>
              </Box>
            </HStack>
          </Box>

          <VStack spacing={7} align="stretch" color="gray.700" fontSize="sm" lineHeight="tall">
            <Box>
              <Heading as="h2" size="md" color="#162237" mb={3} display="flex" alignItems="center" gap={2}>
                <Box w="3px" h="18px" bg="#EAB308" borderRadius="full" />
                1. Accuracy of Content and Omissions
              </Heading>
              <Text>
                While every diligent effort has been taken to prevent errors, typographical slips, or factual omissions, <strong>Navneet Law Studio Pvt. Ltd.</strong>, its associated publishing houses, printers, contributing legal authors, software partners, and management make no warranty, express or implied, concerning the absolute exhaustiveness or uninterrupted operation of the content, information, software algorithms, or literature available across <strong>www.navneetlawstudio.com</strong>.
              </Text>
            </Box>

            <Divider borderColor="gray.100" />

            <Box>
              <Heading as="h2" size="md" color="#162237" mb={3} display="flex" alignItems="center" gap={2}>
                <Box w="3px" h="18px" bg="#EAB308" borderRadius="full" />
                2. Non-Liability for Legal Action or Judicial Decisions
              </Heading>
              <Text>
                No guarantee or indemnity is extended for any action taken or omitted to be taken by an advocate, litigant, judicial authority, or institution based on headnotes, case commentaries, statutes, or digital search outputs obtained through this portal or third-party integrated software suites. Practitioners are strongly advised to cross-verify all case laws and notifications against the official gazettes and certified court records.
              </Text>
            </Box>

            <Divider borderColor="gray.100" />

            <Box>
              <Heading as="h2" size="md" color="#162237" mb={3} display="flex" alignItems="center" gap={2}>
                <Box w="3px" h="18px" bg="#EAB308" borderRadius="full" />
                3. "As Is" and "As Available" Service Provision
              </Heading>
              <Text>
                This website and its digital assets are provided strictly on an "as is" and "as available" basis. Navneet Law Studio shall not be liable for any direct, indirect, punitive, or consequential damages arising from site access interruptions, server downtimes, or technical defects beyond our reasonable control.
              </Text>
            </Box>

            <Divider borderColor="gray.100" />

            <HStack justify="space-between" pt={4} wrap="wrap" gap={3}>
              <Link to="/termsandcondition" style={{ color: '#162237', fontWeight: 600, fontSize: '13px' }}>
                ← View Full Terms & Conditions
              </Link>
              <Link to="/shippingpolicy" style={{ color: '#162237', fontWeight: 600, fontSize: '13px' }}>
                View Shipping & Dispatch Policy →
              </Link>
            </HStack>
          </VStack>
        </Box>
      </Container>
    </Box>
  );
}

export default Disclaimer;
